import { Model } from 'survey-core';

import { AttachmentType } from '~/lib/constants/AddPatientNoteModal.constants';
import { FieldErrorState } from '~/components/maud/patients/note/EditNoteForm';

type BlockerArgs = {
  fieldErrors?: Partial<FieldErrorState>;
  isCarePlanValid: boolean;
  noteTemplateFormModel?: Model;
  uploadInProgressFiles: AttachmentType[];
};

/**
 * Human-readable list of everything preventing a note from being signed, for
 * console diagnostics when the UI does not make the blocker obvious.
 */
export const getSigningBlockers = ({
  fieldErrors,
  isCarePlanValid,
  noteTemplateFormModel,
  uploadInProgressFiles,
}: BlockerArgs): string[] => {
  const blockers = Object.entries(fieldErrors ?? {})
    .filter(([, message]) => !!message)
    .map(([field, message]) => `${field}: ${message}`);

  if (!isCarePlanValid) {
    blockers.push('carePlan: frequencies need to be assessed');
  }

  // SurveyJS renders its own inline errors, but only for questions on screen.
  // Fully optional call so a diagnostic never breaks signing itself.
  noteTemplateFormModel?.getAllQuestions?.()?.forEach((question) => {
    question.errors?.forEach((error) => {
      blockers.push(
        `noteTemplate.${question.name} (${question.title}): ${error.text}`,
      );
    });
  });

  // Count only: file names are provider-supplied and the attachment list
  // already shows which one is still spinning
  if (uploadInProgressFiles?.length) {
    blockers.push(
      `${uploadInProgressFiles.length} attachment(s) still uploading`,
    );
  }

  return blockers;
};
